import {createSvgIcon} from '../create-svg-icon';

export const ArrowRightIcon = createSvgIcon(
  <path d="m10 17 5-5-5-5v10z" />
, 'ArrowRightOutlined');
